<template>
  <div>
    <div v-if="is_super_admin">
      <div style="padding: 12px 16px;">
        <!-- <el-form :inline="true" :model="d_job_search" class="demo-form-inline">
          
          <el-form-item label="岗位名称" class="from-label" >
            <el-input size="small" v-model="d_job_search.job_name" placeholder="请输入岗位名称" clearable></el-input>
          </el-form-item>
          
          <el-form-item label="岗位编码" class="from-label">
            <el-input size="small" v-model="d_job_search.job_code" placeholder="请输入岗位编码" clearable></el-input>
          </el-form-item>
          
          <el-form-item label="岗位状态" class="from-label">

            <el-select size="small" v-model="d_job_form.job_status">
                <el-option label="正常" value="正常"></el-option>
                <el-option label="停用" value="停用"></el-option>
              </el-select>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="search_jobs_func" size="small" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="on_reset" size="small" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
          
        </el-form> -->
    </div>
  
    <div style="padding: 0px 16px;">
      <el-button plain type="primary" @click="on_add_job" size="small" icon="el-icon-plus">新增岗位</el-button>
    </div>

    <div style="padding: 10px 16px;">
      <el-table
        :header-cell-style="{'background-color': '#eff3f8', color: '#606266'}"
        :data="l_table_data"
        style="width: 100%">
        <el-table-column
          prop="job_name"
          align="center"
          label="岗位名称"
          >
        </el-table-column>
        <el-table-column
          prop="job_code"
          align="center"
          label="岗位编码"
          >
        </el-table-column>
        <el-table-column
          prop="job_status"
          align="center"
          label="岗位状态"
          >
         <template slot-scope="scope"> 
            <el-tag type="success" v-if="scope.row.job_status == '正常'">
              <span> 正常 </span>
            </el-tag>
            <el-tag type="danger" v-if="scope.row.job_status == '停用'" >
              <span> 停用 </span>
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column
          prop="create_datetime"
          align="center"
          label="创建时间"
          >
        </el-table-column>

        <el-table-column
          align="center"
          label="操作"
          >
          <template slot-scope="scope">
            <el-button plain round icon="el-icon-edit" type="success" size="small" @click="on_edit_job(scope.$index, scope.row)">编辑</el-button>
            <el-button round icon="el-icon-delete" type="danger" size="small" @click="on_delete_job(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :visible.sync="b_show_dialog" :fullscreen="b_show_fullscreen" :show-close="false" :before-close="this.$dialog_close" style="padding: 12px 16px;">
        
        <div slot="title" class="dialog-title">
            <span style="font-size: 18px; line-height: 24px; color: #303133;">{{ s_dialog_name }}</span>
            <el-button icon="el-icon-close" class='dialog-title-button' @click="b_show_dialog = false"></el-button>
            <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_show_fullscreen = !b_show_fullscreen"></el-button>
        </div>

        <el-form :model="d_job_form" ref="d_job_form" label-width="100px" @class="demo-d_job_form">
          <el-form-item label="岗位名称" prop="job_name">
            <el-input v-model="d_job_form.job_name" ></el-input>
          </el-form-item>

          <el-form-item label="岗位编码" prop="job_code">
            <el-input v-model="d_job_form.job_code"></el-input>
          </el-form-item>

          <el-form-item label="岗位状态" prop="job_status">
            <el-select v-model="d_job_form.job_status">
              <el-option label="正常" value="正常"></el-option>
              <el-option label="停用" value="停用"></el-option>
            </el-select>
          </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="on_submit_job()">{{ s_btn_name }}</el-button>
              <el-button @click="on_cancel_job">取消</el-button> 
            </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    </div>

    <div v-else>
      <div style="text-align: center;">
        <div style="margin-top: 0px;">
          <img src="../../assets/permission_denied.png">
          <div style="margin-top: 20px;">
            <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
  export default {
    name: 'job_system',
    data() {
      return {
        l_table_data: [],

        // 搜索栏
        d_job_search: {
          job_name: '',
          job_code: '',
          job_status: '',
          create_datetime: '',
        },

        // 表单数据
        d_job_form: {},

        b_show_dialog: false,
        b_show_fullscreen: false,
        s_dialog_name: '11',
        s_btn_name: '',
        i_dialog_type: 1,
        is_super_admin: false,
      }
    },

    mounted() {
      // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
      let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
      if (isSuperAdmin == "false") {
        this.is_super_admin = false
        return
      } else {
        this.is_super_admin = true
      }
      // 刷新岗位数据
      this.ref_job_table_data()

     
    },

    methods: {
      // 刷新岗位数据
      async ref_job_table_data(){
        let res = await this.$axios.get('/api/job/')
        console.log(res)
        this.l_table_data = res.data
        console.log(this.l_table_data)
      },

      // 筛选岗位信息
      search_jobs_func(){
        
      },

      // 重置搜索栏
      on_reset(){
        this.d_job_search = {
          job_name: '',
          job_code: '',
          job_status: '',
        }
      },

      // 新增岗位
      on_add_job(){
        this.b_show_dialog = true
        this.b_show_fullscreen = false
        this.s_dialog_name = '新增岗位'
        this.s_btn_name = '新增'
        this.d_job_form = {}
        this.i_dialog_type = 1

      },

      // 编辑岗位
      on_edit_job(index, row){
        this.b_show_dialog = true
        this.b_show_fullscreen = false
        this.s_dialog_name = '编辑岗位'
        this.s_btn_name = '保存'
        this.i_dialog_type = 2
        this.d_job_form = row
        
      },

      // 删除岗位
      on_delete_job(row){
         var _this = this
        this.$confirm('此操作将永久删除该岗位', '删除岗位警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          _this.$axios.delete('/api/job/' + row.job_id + '/').then(
            function(res){
              _this.$message({
                type: 'success',
                message: '删除成功!'
              });
              _this.ref_job_table_data()
            }
          )
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },

      // 确定新增岗位/编辑岗位
      async on_submit_job(){
        console.log(this.d_job_form)
        if(this.i_dialog_type == 1){
          let res = await this.$axios.post('/api/job/', this.d_job_form)
          this.request_waring(res)
        }else{
          let url = '/api/job/' + this.d_job_form.job_id + '/'
          let res = await this.$axios.put(url, this.d_job_form)
          this.request_waring(res)
        }
      },

      // 取消
      on_cancel_job(){
        this.b_show_dialog = false
      },

      // 请求警告
      request_waring(res){
        if (res.status === 201 || res.status === 200){
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.b_show_dialog = false
          this.ref_job_table_data()
        } else {
          this.$message({
            message: '保存失败',
            type: 'error'
          })
        }
      },

    },
  }
</script>

<style>

</style>